import { handleUnauthorizedResponse } from "src/api/api";
import { User } from "src/types/user";

export const ensureNightscoutV2Subject = async (
  user: User | false | null | undefined
): Promise<void> => {
  if (!user || !user?.nsInstance?.validated) {
    return;
  }

  try {
    const accessToken = localStorage.getItem("access_token");
    const response = await fetch(
      `${process.env.REACT_APP_BE_URL}/add-v2-subject`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    if (response.status === 401) {
      handleUnauthorizedResponse();
    }
  } catch (err) {
    console.error("Failed to ensure Nightscout ACCESS_TOKEN:", err);
  }
};
